export enum SalePriceEnum {
  total = 'total',
  sf = 'sf',
  acres = 'acres',
}

export const SalePriceEnumLabels = {
  [SalePriceEnum.total]: 'Total',
  [SalePriceEnum.sf]: 'Per SF',
  [SalePriceEnum.acres]: 'Per Acre',
};
